import { render, staticRenderFns } from "./BlockedTermsAndPhrases.vue?vue&type=template&id=73e67ff6&"
import script from "./BlockedTermsAndPhrases.vue?vue&type=script&lang=ts&"
export * from "./BlockedTermsAndPhrases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports